/* global animationTime, Node */

var ANIMATIONS = {
  getDefaultAnimation: function () {
    return this.FLYING_BLOCKS;
  },
  getDefaultHidingAnimation: function () {
    return this.FLYING_BLOCKS_HIDDING;
  },
  /**
   * @param {number} left
   * @param {number} top
   * @param {function} callback
   * @returns {boolean}
   */
  CART: function (left, top, callback) {
    //create element
    var object = document.createElement("div");
    object.innerHTML = '<div class="top"><div class="rotate img"></div></div>';

    //set position from param
    object.style.left = left + "px";
    object.style.top = top + "px";

    //fix css
    object.style.width = "80px";
    object.style.height = "80px";
    object.style.transition =
      "all " + animationTime * 4 + "ms cubic-bezier(0.25,0.75,1,1)";
    object.style.overflow = "visible";
    object.style.position = "fixed";
    object.style.zIndex = 10000;
    object.children[0].style.transition =
      "all " + animationTime * 4 + "ms cubic-bezier(0.75, 0.25, 1, 1)";
    object.children[0].style.height = "100%";
    object.children[0].style.width = "100%";
    object.children[0].style.overflow = "visible";
    object.children[0].children[0].style.transition =
      "all " + animationTime * 4 + "ms linear";
    object.children[0].children[0].style.height = "100%";
    object.children[0].children[0].style.width = "100%";
    object.children[0].children[0].style.borderRadius = "50%";
    object.children[0].children[0].style.backgroundImage =
      "url(../interface/file_mobile.php)";

    //add object after setting all css to avoid multiple redraw
    document.body.appendChild(object);

    //on iOS window.outerWidth is always 0
    var bodyWidth = window.outerWidth || screen.width;

    //wait for image loaded
    setTimeout(function () {
      object.style.transform =
        "translateX(" + (bodyWidth - parseInt(object.style.left) - 110) + "px)";
      object.style.webkitTransform =
        "translateX(" + (bodyWidth - parseInt(object.style.left) - 110) + "px)";

      object.children[0].style.transform =
        "translateY(-" +
        (parseInt(object.style.top) + 100) * window.devicePixelRatio +
        "px)";
      object.children[0].style.webkitTransform =
        "translateY(-" +
        (parseInt(object.style.top) + 100) * window.devicePixelRatio +
        "px)";

      object.children[0].children[0].style.transform =
        "rotate(-720deg) scale(0.3)";
      object.children[0].children[0].style.webkitTransform =
        "rotate(-720deg) scale(0.3)";
    }, 30);

    //after end of animation
    setTimeout(function () {
      //animate .goToCart
      var goToCartDom = document.querySelector(
        "header.mdl-layout__header div.icon-holder > a.goToCart"
      );
      if (goToCartDom) {
        goToCartDom.style.transform = "scale(1.2)";
        goToCartDom.style.webkitTransform = "scale(1.2)";
        setTimeout(function () {
          var goToCartDom = document.querySelector(
            "header.mdl-layout__header div.icon-holder > a.goToCart"
          );
          goToCartDom.style.transform = null;
          goToCartDom.style.webkitTransform = null;
        }, 230);
      }

      if (typeof callback === "function") callback();

      object.parentNode.removeChild(object);
    }, parseInt(object.style.transitionDuration));
  },
  FLYING_BLOCKS: function (objects, callback) {
    //if user used document.querySelector convert to an array. NodeList not necessary.
    if (objects instanceof Node) objects = [objects];

    if (objects.length === 0) {
      if (typeof callback === "function") callback();
      return;
    }

    /**
     * Set bigger for faster animation
     * @type Number
     */
    var MULTIPLIKATOR = 0.25;

    //set objects to preanimation settings
    for (var i = 0, len = objects.length; i < len; i++) {
      var object = objects[i];
      object.style.cssText +=
        "transition: none;" +
        "-webkit-transform: translateY(10em);" +
        "transform: translateY(10em);" +
        "opacity: 0;";
    }

    //do animation
    for (var i = 0, j = 0, len = objects.length; i < len; i++) {
      setTimeout(function () {
        objects[j].style.cssText +=
          "transition: all " +
          animationTime +
          "ms ease;" +
          "-webkit-transform: translateY(0);" +
          "transform: translateY(0);" +
          "opacity: 1;";
        j++;
        //after end of animation of last object
        //run callback
        if (i === j && typeof callback === "function")
          setTimeout(callback, animationTime);
      }, (i * 100) / (MULTIPLIKATOR * len));
    }
  },
  FLYING_BLOCKS_HIDDING: function (objects, callback) {
    //if user used document.querySelector convert to an array. NodeList not necessary.
    if (objects instanceof Node) objects = [objects];

    if (objects.length === 0) {
      if (typeof callback === "function") callback();
      return;
    }

    /**
     * Set bigger for faster animation
     * @type Number
     */
    var MULTIPLIKATOR = 0.25;

    var bodyHeight = window.innerHeight;
    var objectsToAnimate = [];
    for (var i = 0, len = objects.length; i < len; i++) {
      var object = objects[i];

      //animate only elements in View
      if (
        object.getBoundingClientRect().top <= bodyHeight &&
        object.getBoundingClientRect().bottom >= 0
      ) {
        objectsToAnimate.push(object);
      }
    }

    //do animation
    for (var i = 0, j = 0, len = objectsToAnimate.length; i < len; i++) {
      setTimeout(function () {
        objectsToAnimate[j].style.cssText +=
          "transition: all " +
          animationTime +
          "ms ease;" +
          "opacity: 0;" +
          "-webkit-transform: translateY(-7em);" +
          "transform: translateY(-7em);";
        j++;

        //after end of animation of last object
        //run callback
        if (i === j && typeof callback === "function")
          setTimeout(callback, animationTime);
      }, (i * 100) / (MULTIPLIKATOR * len));
    }
  },
  /**
   * Basicly the same as jQuery version. Height of <i>elements</i> will be
   * decresing until 0. <i>display: none</i> will be set. Stores old CSS-Values
   * on dataset of each element.
   * @param {NodeList} elements
   * @param {function} callback
   * @param {number} time
   * Milliseconds. Do not use float.
   * @returns {undefined}
   */
  SLIDE_UP: function (elements, callback, time) {
    if (elements instanceof Node) elements = [elements];
    if (time === undefined) time = animationTime * 2;

    for (var i = 0, len = elements.length; i < len; i++) {
      var element = elements[i];
      var style = window.getComputedStyle(element);
      var dataset = element.dataset;

      if (dataset.animationSlideUp === "up") continue;
      dataset.animationSlideUp = "up";

      dataset.animationSlideUpDisplayBefore = style.display;
      dataset.animationSlideUpHeightBefore = style.height;
      dataset.animationSlideUpTransitionBefore = style.transition;
      dataset.animationSlideUpOverflowBefore = style.overflow;

      dataset.animationSlideUpMarginTopBefore = style.marginTop;
      dataset.animationSlideUpMarginBottomBefore = style.marginBottom;
      dataset.animationSlideUpPaddingTopBefore = style.paddingTop;
      dataset.animationSlideUpPaddingBottomBefore = style.paddingBottom;

      element.style.height = style.height;

      element.style.cssText =
        "transition: all " +
        time +
        "ms ease;" +
        "height: 0px;" +
        "margin-top: 0px;" +
        "margin-bottom: 0px;" +
        "padding-top: 0px;" +
        "padding-bottom: 0px;" +
        "overflow: hidden;";
    }

    setTimeout(function () {
      for (var i = 0, len = elements.length; i < len; i++) {
        elements[i].style.cssText += "display: none !important;";
      }
      if (typeof callback === "function") callback();
    }, time);
  },
  /**
   * Basicly the same as jQuery version. Works only if elements ware hidden
   * with the SLIDE_UP animation before.
   * Height of <i>elements</i> will be increesing to old value.
   * CSS Values will be get from dataset of each Node.
   * on dataset of each element.
   * @param {NodeList} elements
   * @param {function} callback
   * @param {number} time
   * Milliseconds. Do not use float.
   * @returns {undefined}
   */
  SLIDE_DOWN: function (elements, callback, time) {
    if (elements instanceof Node) elements = [elements];

    if (time === undefined) time = animationTime * 2;

    for (var i = 0, len = elements.length; i < len; i++) {
      var element = elements[i];
      element.style.cssText +=
        "display: " +
        element.dataset.animationSlideUpDisplayBefore +
        " !important;";
    }

    //wait some miliseconds for DOM painting
    setTimeout(function () {
      for (var i = 0, len = elements.length; i < len; i++) {
        var element = elements[i];
        var dataset = element.dataset;

        if (dataset.animationSlideUp === "down") continue;
        dataset.animationSlideUp = "down";

        element.style.cssText +=
          "transition: all " +
          time +
          "ms ease;" +
          "height: " +
          dataset.animationSlideUpHeightBefore +
          ";" +
          "margin-top: " +
          dataset.animationSlideUpMarginTopBefore +
          ";" +
          "margin-bottom: " +
          dataset.animationSlideUpMarginBottomBefore +
          ";" +
          "padding-top: " +
          dataset.animationSlideUpPaddingTopBefore +
          ";" +
          "padding-bottom: " +
          dataset.animationSlideUpPaddingBottomBefore +
          ";" +
          "overflow: " +
          dataset.animationSlideUpOverflowBefore +
          ";";
      }

      setTimeout(function () {
        for (var i = 0, len = elements.length; i < len; i++) {
          var element = elements[i];
          element.style.transition =
            element.dataset.animationSlideUpTransitionBefore;
        }
        if (typeof callback === "function") callback();
      }, time);
    }, 20);
  },
  WIGGLE: function (element, callback, px) {
    element.style.cssText += "transition: all 100ms linear;";

    setTimeout(function () {
      var intervalCount = 1;
      var interval = setInterval(function () {
        element.style.cssText +=
          "transform: translateX(" +
          (function () {
            switch (intervalCount % 3) {
              case 0:
                return 0;
              case 1:
                return px ? px + "px" : "3px";
              case 2:
                return px ? "-" + px + "px" : "-3px";
            }
          })() +
          ")";
        if (intervalCount >= 6) {
          clearInterval(interval);
          if (typeof callback === "function") callback();
        }
        intervalCount++;
      }, 100);
    }, 10);
  },
  /**
   * Fades out elements in a facy way. CSS transform value will be lost.
   * @param {NodeList} elements
   * All elements has to have the same parentNode.
   * @param {function|undefined} callback
   * @returns {undefined}
   */
  KICK_BACK: function (elements, callback) {
    var parent = elements[0].parentNode;
    var parentPerspective = window.getComputedStyle(parent).perspective;

    //save this for restore
    var oldParentPerspective = parentPerspective;

    //if parent has no perspective, set default one
    if (parentPerspective === "none") {
      parentPerspective = 100;
      parent.style.perspective = parentPerspective + "px";
    } else {
      parentPerspective = parseInt(parentPerspective);
    }

    //apply new CSS for each element
    for (var i = 0, len = elements.length; i < len; i++) {
      var element = elements[i];
      element.style.transition = "all " + animationTime * 2 + "ms ease";
      element.style.webkitTransform =
        "translateZ(-" +
        parseInt(parentPerspective / 3) +
        "px) rotateX(" +
        parseInt(parentPerspective / 100) +
        "deg)";
      element.style.transformransform =
        "translateZ(-" +
        parseInt(parentPerspective / 3) +
        "px) rotateX(" +
        parseInt(parentPerspective / 100) +
        "deg)";
      element.style.opacity = "0";
      element.style.webkitFilter = "blur(20px)";
      element.style.filter = "blur(20px)";
    }

    setTimeout(function () {
      //restore old perspecitve of partent. Just in case.
      parent.style.perspective = oldParentPerspective;
      if (typeof callback === "function") callback();
    }, animationTime * 2);
  },
};
